import { Button } from "@/components/ui/button";

const optionalProp = () => null;

const Header = ({ logoSrc, logoAlt = "Logo", onLoginClick, onGetStartedClick }) => {
  return (
    <header className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between text-white">
      <div className="flex items-center gap-4">
        <div className="flex h-20 w-35 items-center justify-center overflow-hidden">
            <img src="../parkioo_log_white.png" alt={logoAlt} className="h-full w-full object-contain p-2" />
        </div>
      </div>

      <div className="flex gap-3">
        <Button
          type="button"
          onClick={onLoginClick}
          className="rounded-full border border-white/20 bg-white/10 px-6 text-white hover:bg-white/20"
        >
          Login
        </Button>
        <Button
          type="button"
          onClick={onGetStartedClick}
          className="rounded-full bg-[#FF6B35] px-6 text-white hover:bg-[#E55A28]"
        >
          Get Started
        </Button>
      </div>
    </header>
  );
};

Header.propTypes = {
  logoSrc: optionalProp,
  logoAlt: optionalProp,
  onLoginClick: optionalProp,
  onGetStartedClick: optionalProp,
};

export default Header;